import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { inset } from 'app/shared/styles/_spacing';

// Components
import LinkerBase from 'app/shared/modules/Linker';

export const NearbyListingsArticle = styled.article`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${colors['$hpx-grey-100']};
`;

export const NearbyListingsText = styled.p`
  padding-top: 16px;
  padding-bottom: 16px;
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
  text-align: center;
`;

export const NearbyListingsItem = styled.div`
  padding: 10px 0px;
`;

export const NearbyListingsAreaLink = styled(LinkerBase)`
  ${font.md};
`;

export const BoldText = styled.b`
  padding-left: 4px;
`;

export const LightText = styled.p`
  ${font.sm};
  color: ${colors['$hpx-grey-600']};
`;

export const List = styled.ul`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
`;

export const AreaSection = styled.div`
  &:not(:last-child) {
    padding-bottom: 32px;
  }
`;
